import WidgetsRender, { WidgetItem } from '@/components/main/widgets/WidgetsRender';
import BannerSlider from './BannerSlider';
import { SliderItemFrom } from '@/core/models/slider-model';
import Container from '@/components/shared/Container';

type MainViewProps = {
    slides: SliderItemFrom[];
    widgets?: WidgetItem[];
};

export default async function MainView({ slides, widgets }: MainViewProps) {
    return (
        <>
            <BannerSlider slides={slides} />
            <Container className="mt-10 space-y-18">
                <div className="grid grid-cols-12 gap-x-4 gap-y-11 md:gap-x-13 md:gap-y-13 lg:gap-y-18 lg:gap-x-18">
                    <WidgetsRender widgets={widgets} />
                </div>
            </Container>


        </>
    );
}
